import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

type Props = {
    open: boolean;

    // 'course' or 'playlist', lower case.
    itemLabel: string;
    itemTitle: string;
    deleting: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

export default function ConfirmDeleteItemDialog({ open, itemLabel, itemTitle, deleting, onCancel, onConfirm }: Props) {
    return (
        <Dialog open={open} onClose={onCancel} maxWidth="sm">
            <DialogTitle>{`Delete this ${itemLabel}?`}</DialogTitle>

            <DialogContent>
                <DialogContentText>{`You sure you want to delete "${itemTitle}"?`}</DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel} disabled={deleting}>
                    Cancel
                </Button>
                <Button variant="contained" color="secondary" onClick={onConfirm} disabled={deleting}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
